/**
 * Facade Geral Uazapi
 * Arquitetura: Exporta todas as funções dos subdomínios, mantendo a compatibilidade do resto da app.
 * Segurança e Isolamento: Funções distribuídas por subpastas respeitando limites de linhas e escopos (SOLID).
 */

// Instância (Lifecycle, Conexão, Status, Setup)
import { 
    createInstance, 
    getQRCode, 
    getConnectionState, 
    fetchInstanceDetails, 
    getInstanceProfile, 
    deleteInstance, 
    disconnectInstance, 
    reconnectInstance, 
    deleteInstanceCompletely, 
    getInstanceStatusFromDB, 
    getOrganizationInstances 
} from './uazapi/instance';

// Mensageria (Envio, Read, React, Media e Lógica outbound)
import { 
    sendTextMessage, 
    sendImage, 
    sendVideo, 
    sendAudio, 
    sendDocument, 
    sendSticker, 
    sendContactMessage,
    sendLocationMessage,
    sendPixButtonMessage,
    sendReaction, 
    editMessage, 
    deleteMessageFromChat as deleteMessage, 
    fetchMessages 
} from './uazapi/messages';

// Histórico (Sincronização, Extração de BD e Contatos)
import { 
    fetchChats, 
    fetchContacts, 
    fetchUnreadMessages, 
    syncHistory 
} from './uazapi/history';

// Webhooks (Configuração Uazapi)
import { 
    setupWebhook, 
    getWebhookConfig 
} from './uazapi/webhook';

// ============================================================================
// EXPORT FACADE OBJECT
// ============================================================================

export const uazapiService = {
    // Instance Core
    createInstance,
    getQRCode,
    getConnectionState,
    fetchInstanceDetails,
    getInstanceProfile,
    deleteInstance,
    disconnectInstance,
    reconnectInstance,
    deleteInstanceCompletely,
    getInstanceStatusFromDB,
    getOrganizationInstances,
    
    // Messaging
    fetchMessages,
    sendTextMessage,
    sendImage,
    sendVideo,
    sendAudio,
    sendDocument,
    sendSticker,
    sendContactMessage,
    sendLocationMessage,
    sendPixButtonMessage,
    sendReaction,
    editMessage,
    deleteMessage,

    // Chats & History
    fetchChats,
    fetchContacts,
    fetchUnreadMessages,
    syncHistory,

    // Webhooks
    setupWebhook,
    getWebhookConfig,
};

// Aliases globais originais (se usados destruturados em outros locais)
export {
    createInstance, 
    getQRCode, 
    getConnectionState, 
    fetchInstanceDetails, 
    getInstanceProfile, 
    deleteInstance, 
    disconnectInstance, 
    reconnectInstance, 
    deleteInstanceCompletely, 
    getInstanceStatusFromDB, 
    getOrganizationInstances,
    sendTextMessage, 
    sendImage, 
    sendVideo, 
    sendAudio, 
    sendDocument, 
    sendSticker,
    sendContactMessage,
    sendLocationMessage,
    sendPixButtonMessage,
    sendReaction, 
    editMessage, 
    deleteMessage,
    fetchMessages,
    fetchChats, 
    fetchContacts, 
    fetchUnreadMessages, 
    syncHistory,
    setupWebhook, 
    getWebhookConfig 
};
